import { memo, useMemo } from 'react';
import {
    useNetSuiteItemReceiptItemLinesFieldSettings,
    useNetSuiteLineCustomFieldsDefinition,
} from 'shared/hooks/(requests)';

import { NetSuiteLineTable } from '../NetSuiteLineTable/NetSuiteLineTable';
import { getColumnDefinitions } from './NetSuiteItemReceiptItemLines.config';
import { messages } from './NetSuiteItemReceiptItemLines.messages';
import { NetSuiteItemReceiptItemLinesProps } from './NetSuiteItemReceiptItemLines.types';

export const NetSuiteItemReceiptItemLines = memo((props: NetSuiteItemReceiptItemLinesProps) => {
    const { itemLines, companyCustomFields, documentFields, exchangeRate } = props;

    const fieldSettings = useNetSuiteItemReceiptItemLinesFieldSettings(documentFields);

    const customFieldsColumnDefinitions = useNetSuiteLineCustomFieldsDefinition(itemLines, companyCustomFields);

    const columnDefinitions = useMemo(
        () =>
            getColumnDefinitions({
                fieldSettings,
                customFieldsColumnDefinitions,
                exchangeRate,
            }),
        [fieldSettings, customFieldsColumnDefinitions, exchangeRate]
    );

    if (itemLines.length === 0) {
        return null;
    }

    return (
        <NetSuiteLineTable
            title={messages.sectionHeaderText}
            columnDefinitions={columnDefinitions}
            lineItems={itemLines}
        />
    );
});

NetSuiteItemReceiptItemLines.displayName = 'NetSuiteItemReceiptItemLines';
